import React from 'react';
interface Props {
  children?: any | undefined;
  className?: string | undefined;
  style?: React.CSSProperties | undefined;
  childStyle?: React.CSSProperties | undefined;
  childClassName?: string | undefined;
}
const FlatListAutoHeight = ({ style, className, children, childStyle, childClassName }: Props) => {
  return (
    <div
      style={{
        flexGrow: 1,
        overflow: 'hidden',
        position: 'relative',
        height: '100%',
        ...style
      }}
      className={className}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: 'auto',
          ...childStyle
        }}
        className={childClassName}>
        {children}
      </div>
    </div>
  );
};
export default React.memo(FlatListAutoHeight);
